import {
  AutoFullImage,
  Button,
  Container,
  Heading,
  Image,
  Link,
  Section,
  Subtitle,
  Title,
} from 'components/common';

export const GiftCardContent = () => {
  const giftCardsUrl = process.env.NEXT_PUBLIC_GIFT_CARDS_URL || '';

  return (
    <>
      <Image
        src="/assets/images/giftcards/giftcard-normal-banner.jpg"
        alt="Gift Card Banner"
        layout="responsive"
        height="50px"
        width="100%"
        objectFit="fill"
      />

      <Section className="tw-mt-10">
        <Container>
          <Heading className="tw-mb-10" textAlign="center">
            <Title>
              Wanna let a Friend or Loved One try Singapore's
              Shiok-est Meal Prep?
            </Title>
            <Subtitle className="tw-mb-1">
              These Gift Cards are PERFECT for You!
            </Subtitle>
          </Heading>
          <p className="tw-text-center">
            Is someone’s birthday coming? A house-warming party is
            around the corner? Perhaps, you just want to show someone
            you care? In our not-so-humble opinion, an enjoyable
            healthy diet is hands-down the best gift you can give! So,
            solve your gifting woes by grabbing a bunch of Yummy Bros
            Gift Cards!
          </p>
        </Container>
      </Section>

      <div className="tw-w-1/2 lg:tw-w-2/5 xl:tw-w-1/3 tw-w tw-m-auto">
        <AutoFullImage
          src="/assets/images/giftcards/giftcard-normal-vouchers.png"
          alt="Gift Cards"
        />
      </div>

      <Container>
        <div className="tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-2">
          <div>
            <Title>How To Buy</Title>
            <ol className="tw-list-decimal tw-pl-[40px]">
              <li>
                Go to our secure{' '}
                <Link to={giftCardsUrl} target="_blank">
                  <span>purchase page</span>
                </Link>
              </li>
              <li>Choose quantity of Gift Cards and make payment</li>
              <li>
                We'll send you the digital Gift Card(s) via email by
                the next business day
              </li>
              <li>
                Send them to your loved ones and wish them the best in
                fitness & health!!
              </li>
            </ol>

            <Link to={giftCardsUrl} target="_blank">
              <Button variant="outlined" className="tw-mt-3 tw-mb-10">
                <>
                  <span>BUY NOW</span>
                  <i className="icon-long-arrow-right"></i>
                </>
              </Button>
            </Link>
          </div>

          <div>
            <Title>Some Simple T&Cs</Title>
            <ul className="tw-list-disc tw-pl-[40px]">
              <li>
                Gift Cards are valid for 6 months from date of
                purchase
              </li>
              <li>
                Only 1 Gift Card can be used per order and are not
                stackable
              </li>
              <li>
                Delivery fees are applicable to orders with gift cards
                applied
              </li>
              <li>
                Unused value cannot be redeemed in cash or used on a
                subsequent order
              </li>
              <li>
                Don't worry! The above are clearly listed on the
                digital Gift Cards!
              </li>
            </ul>
          </div>
        </div>
      </Container>
    </>
  );
};
